import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { Video } from '@/src/types/video'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useOnboarding } from '@/src/store/onboarding-store'
import { useLocationQuery } from '../guest/location-query'

interface HomeVideoResponse {
  videos: Video[]
  offset: number
}

export const useHomeVideos = () => {
  const { languageIds, interestIds } = useOnboarding()
  const { data: data, isFetched : isLocationFetched} = useLocationQuery()
  const { user, _hasHydrated } = useUser()
  const { accessToken } = useToken()
  return useInfiniteQuery({
    initialPageParam: { offset: 0 },
    queryKey: ['home-videos', user, languageIds, interestIds],
    queryFn: async ({ pageParam }): Promise<HomeVideoResponse> => {
      const newOffset = pageParam.offset
      if (user) {
        const dataProps = {
          limit: 12,
          offset: newOffset,
          city: data?.city || '',
          country: data?.country || '',
          countryCode: data?.countryCode || '',
        }
        const response = await makeApiRequest({
          method: 'POST',
          url: '/Landing/getLangingData_Withlogin',
          isAuthenticated: true,
          data: dataProps,
          fallbackError: 'Error while fetching home videos',
          isV3Api:true
        })
        const videos: Video[] = response.response.data
        return { videos, offset: newOffset }
      } else {
        const dataProps = {
          limit: 12,
          offset: newOffset,
          city: data?.city || '',
          country: data?.country || '',
          countryCode: data?.countryCode || '',
          languageId: languageIds,
          interestId: interestIds,
          categoryId: null,
        }
        const response = await makeApiRequest({
          method: 'POST',
          url: '/Landing/getLangingData_Withoutlogin',
          isAuthenticated: true,
          data: dataProps,
          fallbackError: 'Error while fetching home videos',
          isV3Api:true
        })
        const videos: Video[] = response.response.data
        return { videos, offset: newOffset }
      }
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.videos.length === 0) return undefined
      const newOffset = lastPage.offset + 12
      return { offset: newOffset }
    },
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
    enabled: !!isLocationFetched && (!user || !!accessToken) && _hasHydrated
    
  })
}
